module.exports = __webpack_public_path__ + "static/media/laser.f92b8fe.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/laser.mp3
// module id = NapY
// module chunks = 74